import {takeEvery} from 'redux-saga/effects'

import {
  ADD_SCHOOL_LECTURE,
  ADD_SCHOOL_LECTURE_COMMENT,
  DELETE_COMMENT,
  DELETE_SCHOOL_LECTURE,
  GET_ALL_COMMENTS,
  GET_SCHOOL_LECTURE,
  GET_SCHOOL_LECTURES,
  GET_SCHOOL_LECTURE_ONLINE_USER,
  UPDATE_COMMENT,
  UPDATE_SCHOOL_LECTURE,
} from '../../../Actions/School/Lecture/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_SCHOOL_LECTURES, fetchData)
  yield takeEvery(GET_SCHOOL_LECTURE, fetchData)
  yield takeEvery(DELETE_SCHOOL_LECTURE, fetchData)
  yield takeEvery(UPDATE_SCHOOL_LECTURE, fetchData)
  yield takeEvery(ADD_SCHOOL_LECTURE, fetchData)
  yield takeEvery(GET_SCHOOL_LECTURE_ONLINE_USER, fetchData)
  yield takeEvery(ADD_SCHOOL_LECTURE_COMMENT, fetchData)
  yield takeEvery(UPDATE_COMMENT, fetchData)
  yield takeEvery(DELETE_COMMENT, fetchData)
  yield takeEvery(GET_ALL_COMMENTS, fetchData)
}

export default dataSaga
